import { GlobalThemeOverrides } from 'naive-ui';
const getCSSLengthVariable = (variableName: string): string => {
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue(variableName)
      .trim() + 'px'
  );
};
export const getCSSColorVariable = (variableName: string): string => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
};

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: getCSSColorVariable('--dd3-color-text-brand'),
    primaryColorHover: getCSSColorVariable('--dd3-color-text-brand'),
    primaryColorPressed: getCSSColorVariable('--dd3-color-text-brand'),
    textColor1: getCSSColorVariable('--dd3-color-text'),
    textColor2: getCSSColorVariable('--dd3-color-text'),
    textColor3: getCSSColorVariable('--dd3-color-text'),
    textColorDisabled: getCSSColorVariable('--dd3-color-text-disabled'),
    fontSize: getCSSLengthVariable('--dd3-font-size-350'),
    fontSizeMedium: getCSSLengthVariable('--dd3-font-size-350'),
    fontSizeSmall: getCSSLengthVariable('--dd3-font-size-300'),
    lineHeight: getCSSLengthVariable('--dd3-font-line-height-500'),
    heightMedium: getCSSLengthVariable('--dd3-height-900'),
    iconColorDisabled: getCSSLengthVariable('--dd3-color-icon-brand-disabled'),
  },

  Button: {
    borderRadiusMedium: 'calc(var(--dd3-border-radius-050) * 1px)',
    color: 'var(--dd3-color-bg-fill)',
    border:
      'calc(var(--dd3-border-width-025) * 1px)' +
      ' solid ' +
      'var( --dd3-color-input-border)',
    colorHover: 'var(--dd3-color-bg-fill)',
    borderHover:
      'calc(var(--dd3-border-width-025) * 1px)' +
      ' solid ' +
      'var(--dd3-color-border-brand)',
    textColorHover: 'var(--dd3-color-text-brand)',
    colorDisabled: 'var(--dd3-color-bg-fill)',
    colorPrimary: 'var(--dd3-color-bg-fill-brand)',
    textColorPrimary: 'var(--dd3-color-text-brand-on-bg-fill)',
    colorHoverPrimary: 'var(--dd3-color-bg-fill-brand-hover)',
    textColorHoverPrimary: 'var(--dd3-color-text-brand-on-bg-fill)',

    colorError: 'var(--dd3-color-bg-fill-critical)',
    textColorError: 'var(--dd3-color-text-brand-on-bg-fill)',
    colorHoverError: 'var(--dd3-color-bg-fill-critical-hover)',
    textColorHoverError: 'var(--dd3-color-text-brand-on-bg-fill)',
    colorDisabledError: 'var(--dd3-color-black-alpha-100)',
    textColorDisabledErrorr: 'var(--dd3-color-text-secondary)',

    colorSecondary: 'var(--dd3-color-bg-fill-secondary)',
    colorSecondaryHover: 'var(--dd3-color-bg-fill-secondary)',
    colorSecondaryDisabled: 'var(--dd3-color-black-alpha-100)',
    colorTertiary: 'var(--dd3-color-bg-fill-secondary)',
    colorTertiaryHover: 'var(--dd3-color-bg-fill-secondary)',
    colorTertiaryDisabled: 'var(--dd3-color-black-alpha-100)',
    colorQuaternary: 'var(--dd3-color-bg-fill)',
    colorQuaternaryHover: 'var(--dd3-color-bg-fill-secondary)',
    colorQuaternaryDisabled: 'var(--dd3-color-black-alpha-100)',
  },
  Tag: {
    borderRadius: 'var(--dd3-border-radius-200)',
  },
  Card: {
    color: 'var(--dd3-color-bg-surface)',
    titleFontSizeMedium: 'calc(var(--dd3-text-heading-md-font-size) * 1px) ',
    titleFontWeight: 'var(--dd3-text-heading-md-font-weight)',
  },
  Menu: {
    borderRadius: 'var(--dd3-border-radius-100)',
    itemColorHover: 'var(--dd3-color-bg-fill-hover)',
    itemColorActive: 'var(--dd3-color-bg-fill-hover)',
  },
  DataTable: {
    thColor: 'var(--dd3-color-bg-surface)',
    borderColor: 'var(--dd3-color-border)',
  },
  Table: {
    thColor: 'var(--dd3-color-bg-surface)',
    borderColor: 'var(--dd3-color-border)',
  },
  Form: {
    asteriskColor: 'var(--dd3-color-text-brand)',
    labelFontWeight: 'var(--dd3-text-body-md-medium-font-weight)',
  },
  Input: {
    heightMedium: 'calc(var(--dd3-height-900) * 1px) ',
    borderRadius: 'calc(var(--dd3-border-radius-050) * 1px) ',
    border:
      'calc(var(--dd3-border-width-025) * 1px)' +
      ' solid ' +
      'var( --dd3-color-input-border)',
  },
  PageHeader: {
    titleFontSize: 'calc(var(--dd3-size-500) * 1px)',
  },
  Typography: {
    headerFontSize1: 'calc(var(--dd3-text-heading-3xl-font-size) * 1px) ',
    headerFontSize2: 'calc(var(--dd3-text-heading-2xl-font-size) * 1px) ',
    headerFontSize3: 'calc(var(--dd3-text-heading-xl-font-size) * 1px) ',
    headerFontSize4: 'calc(var(--dd3-text-heading-lg-font-size) * 1px) ',
    headerFontSize5: 'calc(var(--dd3-text-heading-md-font-size) * 1px) ',
    headerFontSize6: 'calc(var(--dd3-text-heading-sm-font-size) * 1px) ',
    headerMargin1: '0px 0 0px 0',
    headerMargin2: '0px 0 0px 0',
    headerMargin3: '0px 0 0px 0',
    headerMargin4: '0px 0 0px 0',
    headerMargin5: '0px 0 0px 0',
    headerMargin6: '0px 0 0px 0',
  },
  Checkbox: {
    colorDisabledChecked: 'var(--dd3-color-icon-brand-disabled)',
    checkMarkColorDisabledChecked: 'white',
  },
  Steps: {
    splitorColorProcess: 'white',
    indicatorSizeSmall: 'calc(var(--dd3-size-450) * 1px) ',
    indicatorIconSizeSmall: 'calc(var(--dd3-size-450) * 1px) ',
  },
};

export default themeOverrides;
